import React from 'react';

const AddService = () => {
    return (
        <div>
            <h2 className='text-5xl' >Add Services</h2> 
        </div>
    );
};

export default AddService;